export default __webpack_public_path__ + "static/media/logo_short.b68c1411.png";